import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  useTheme,
  Button,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
  Typography,
  Box,
} from '@material-ui/core';
import React, { useEffect, useState, useRef } from 'react';
import bonusProductAPI from '../../middleware/bonusProductAPI';
import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined';
import { trim } from 'lodash';
import { alertError } from '../../Util/Util';
import { BonusProductQRCodeStatus, LIST_PAGE_COUNT } from '../../data/common';
import TableEmpty from '../../components/TableEmpty';
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';
import TableLoading from '../../components/TableLoading';
import BonusProductQRCodeTable from '../../components/BonusProduct/BonusProductQRCodeTable';
import KeyboardReturnRoundedIcon from '@material-ui/icons/KeyboardReturnRounded';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import Swal from 'sweetalert2';
import QrCodeWithLogo from 'qrcode-with-logos';
import { saveAs } from 'file-saver';
import allQRCodeBackground from '../../images/bonusProduct/couponWithQRCode.jpg';
import MergeTypeRoundedIcon from '@material-ui/icons/MergeTypeRounded';
import WallpaperRoundedIcon from '@material-ui/icons/WallpaperRounded';
import DeleteForeverRoundedIcon from '@material-ui/icons/DeleteForeverRounded';

const BonusProductQRCodeModal = (props) => {
  const { close, isOpen, bonusProductId } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [qrcodes, setQRCodes] = useState();
  const [qrcodeTotal, setQRCodeTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const count = LIST_PAGE_COUNT;
  const [pageStep, setPageStep] = useState('list');
  const [createQRCodeCount, setCreateQRCodeCount] = useState('');
  const combinedFileRef = useRef();
  const [combinedImage, setCombinedImage] = useState();

  useEffect(() => {
    if (pageStep === 'list') {
      getQRCodes();
    }
  }, [bonusProductId, page, pageStep]);

  const getQRCodes = () => {
    setIsLoading(true);

    bonusProductAPI
      .getQRCodes(page, count, BonusProductQRCodeStatus.ALL, bonusProductId)
      .then(
        (rs) => {
          if (rs.totalCount <= 0) {
            setQRCodes(undefined);
            setQRCodeTotal(0);
          } else {
            setQRCodes(rs.bonusProductQRCodeList);
            setQRCodeTotal(rs.totalCount);
          }
        },
        (error) => {
          alertError(error);
        },
      )
      .then(() => {
        setIsLoading(false);
      });
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      close();
    }
  };

  const addBonusProductQRCodes = (count) => {
    if (trim(count) !== '' && parseInt(count, 10) > 0) {
      setIsLoading(true);

      bonusProductAPI
        .addQRCodes(bonusProductId, count)
        .then(
          (rs) => {
            Swal.fire({
              toast: true,
              position: 'top-center',
              showConfirmButton: false,
              timer: 3000,
              title: '產生完成',
              icon: 'success',
            });
            handleToList();
          },
          (error) => {
            alertError(error);
          },
        )
        .then(() => {
          setIsLoading(false);
        });
    } else {
      Swal.fire({
        title: '請輸入正確的數量',
        icon: 'warning',
      });
    }
  };

  const handleToAddQRCode = () => {
    setPageStep('addQRCode');
  };

  const handleToList = () => {
    setPageStep('list');
    setCreateQRCodeCount('');
  };

  const handleChangeCreateQRCodeCount = (e) => {
    if (/^[0-9]*$/.test(e.target.value)) {
      setCreateQRCodeCount(trim(e.target.value));
    }
  };

  const handleAddQRcodes = () => {
    if (createQRCodeCount >= 600) {
      Swal.fire({
        title: `確認要產生 ${createQRCodeCount} 個 QRCode 嗎？`,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      }).then((rs) => {
        if (rs.value) {
          addBonusProductQRCodes(createQRCodeCount);
        }
      });
    } else {
      addBonusProductQRCodes(createQRCodeCount);
    }
  };

  const downloadQRCode = async (QRCode) => {
    setIsLoading(true);

    const fileName =
      trim(QRCode.bonusProductQRCodeId) +
      '-' +
      QRCode.bonusProductInfo.name +
      '.png';
    const qrcodeCanvas = document.createElement('canvas');
    const qrcode = new QrCodeWithLogo({
      canvas: qrcodeCanvas,
      content: QRCode.qRCodeValue,
      width: 100,
      nodeQrCodeOptions: {
        margin: 1,
      },
    });

    qrcode.downloadImage(fileName);

    setIsLoading(false);
  };

  const downloadAllQRCode = () => {
    setIsLoading(true);

    return bonusProductAPI
      .getQRCodes(
        1,
        99999999,
        BonusProductQRCodeStatus.FOR_SALE,
        bonusProductId,
      )
      .then((response) => {
        const zip = require('jszip')();

        return getAllUrlQrcodeImg(response.bonusProductQRCodeList).then(
          (allQrCodeImg) => {
            for (let urlQrCode of allQrCodeImg) {
              zip.file(urlQrCode.name, urlQrCode.img.split('base64,')[1], {
                base64: true,
              });
            }

            return zip.generateAsync({ type: 'blob' }).then((content) => {
              saveAs(content, `紅利商品${bonusProductId}_全部待售QRCode.zip`);

              setIsLoading(false);
            });
          },
        );
      });
  };

  const getAllUrlQrcodeImg = async (nodes) => {
    let qrcodes = [];

    for (let node of nodes) {
      const fileName =
        trim(node.bonusProductQRCodeId) +
        '-' +
        node.bonusProductInfo.name +
        '.png';
      const qrcodeCanvas = document.createElement('canvas');
      const qrcode = new QrCodeWithLogo({
        canvas: qrcodeCanvas,
        content: node.qRCodeValue,
        width: 260,
      });

      await qrcode.toCanvas().then(() => {
        qrcodes.push({
          name: fileName,
          img: qrcodeCanvas.toDataURL('image/png'),
          id: node.bonusProductQRCodeId,
        });
      });
    }

    return qrcodes;
  };

  const downloadCombinedQRCode = () => {
    if (!combinedImage) {
      Swal.fire({
        title: '請選擇合成圖片',
        icon: 'warning',
      });

      return false;
    }

    setIsLoading(true);

    return bonusProductAPI
      .getQRCodes(
        1,
        99999999,
        BonusProductQRCodeStatus.FOR_SALE,
        bonusProductId,
      )
      .then((response) => {
        const zip = require('jszip')();

        return getAllUrlQrcodeImg(response.bonusProductQRCodeList).then(
          (allQrCodeImg) => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            canvas.width = combinedImage.width;
            canvas.height = combinedImage.height;

            const positionInfo = {
              qrcode: {
                startX: 2177,
                startY: 634,
                gapX: 2421,
                gapY: 828,
              },
              serial: {
                startX: 383,
                startY: 843,
                gapX: 2421,
                gapY: 828,
              },
            };

            function loadImageAsync(src) {
              return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => resolve(img);
                img.onerror = reject;
                img.src = src;
              });
            }

            async function drawAllQrCodes(ctx, allQrCodeImg, positionInfo) {
              let nowIndex = 0;
              let paperNumber = 1;
              let qrcodeNumber = 0;
              const allQRCodeImgTotal = allQrCodeImg.length;

              for (let urlQrCode of allQrCodeImg) {
                qrcodeNumber = qrcodeNumber + 1;

                if (nowIndex === 8) {
                  nowIndex = 0;
                }

                if (nowIndex === 0) {
                  ctx.drawImage(
                    combinedImage,
                    0,
                    0,
                    canvas.width,
                    canvas.height,
                  );
                }

                try {
                  const img = await loadImageAsync(urlQrCode.img);
                  const xCount = nowIndex % 2 !== 0 ? 1 : 0;
                  const yCount = Math.floor(nowIndex / 2);
                  const qrcodex =
                    positionInfo.qrcode.startX +
                    xCount * positionInfo.qrcode.gapX;
                  const qrcodey =
                    positionInfo.qrcode.startY +
                    yCount * positionInfo.qrcode.gapY;
                  const serialx =
                    positionInfo.serial.startX +
                    xCount * positionInfo.serial.gapX;
                  const serialy =
                    positionInfo.serial.startY +
                    yCount * positionInfo.serial.gapY;

                  ctx.drawImage(img, qrcodex, qrcodey, 260, 260);

                  ctx.font = 'normal 60px Arial';
                  ctx.fillStyle = '#f50057';
                  ctx.textAlign = 'left';

                  const serial = String(urlQrCode.id).padStart(6, '0');
                  const label = `No.     ${serial}`;

                  ctx.fillText(label, serialx, serialy);
                } catch (err) {
                  console.error(`圖片載入失敗: ${urlQrCode.name}`, err);
                }

                if (nowIndex === 7 || allQRCodeImgTotal === qrcodeNumber) {
                  zip.file(
                    '第' + paperNumber + '張.png',
                    canvas.toDataURL('image/png').split('base64,')[1],
                    {
                      base64: true,
                    },
                  );

                  paperNumber = paperNumber + 1;

                  ctx.clearRect(0, 0, canvas.width, canvas.height);
                }

                nowIndex += 1;
              }

              zip.generateAsync({ type: 'blob' }).then((content) => {
                saveAs(
                  content,
                  `合成_紅利商品${bonusProductId}_全部待售QRCode.zip`,
                );
                setIsLoading(false);
              });
            }

            drawAllQrCodes(ctx, allQrCodeImg, positionInfo);
          },
        );
      });
  };

  const goToCombined = () => {
    setPageStep('combined');
  };

  const handleCombinedFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    setIsLoading(true);

    const reader = new FileReader();

    reader.onload = (event) => {
      const img = new window.Image();
      img.src = event.target.result;
      img.onload = () => setCombinedImage(img);
      setIsLoading(false);
    };

    reader.readAsDataURL(file);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={isOpen}
      onClose={handleClose}
      fullWidth={true}
      maxWidth="md">
      <DialogTitle>
        產品 QRCode 設定
        <Typography variant="overline" display="block" gutterBottom>
          當此商品僅使用在紙本上時，可將此商品設定下線狀態。
        </Typography>
      </DialogTitle>

      <DialogContent>
        {pageStep === 'list' && (
          <>
            {isLoading && <TableLoading />}

            {!isLoading && qrcodeTotal <= 0 && (
              <TableEmpty message="目前無設定 QRCode" />
            )}

            {!isLoading && qrcodeTotal > 0 && (
              <BonusProductQRCodeTable
                QRCodes={qrcodes}
                total={qrcodeTotal}
                page={page}
                setPage={setPage}
                isLoading={isLoading}
                downloadQRCode={downloadQRCode}
              />
            )}
          </>
        )}

        {pageStep === 'addQRCode' && (
          <FormControl fullWidth>
            <InputLabel htmlFor="qrcode-count">
              輸入欲產生 QRCode 的數量
            </InputLabel>
            <Input
              id="qrcode-count"
              value={createQRCodeCount}
              onChange={handleChangeCreateQRCodeCount}
              startAdornment={
                <InputAdornment position="start">數量</InputAdornment>
              }
              disabled={isLoading}
            />
          </FormControl>
        )}

        {pageStep === 'combined' && (
          <Box textAlign="center" p={2}>
            {combinedImage && (
              <div>
                <Typography variant="h5" style={{ marginBottom: '12px' }}>
                  請按下載，即可進行合成並下載。
                </Typography>

                <Typography variant="body1" style={{ marginBottom: '12px' }}>
                  合成圖片時會需要較久的時間和資源，請等待儲存視窗出現。
                  <br />
                  合成圖片位置皆固定無法修改!
                </Typography>

                <Button
                  variant="contained"
                  color="default"
                  onClick={() => {
                    setCombinedImage(undefined);
                  }}
                  startIcon={<DeleteForeverRoundedIcon />}
                  size="small"
                  disabled={isLoading}>
                  移除
                </Button>
              </div>
            )}

            {!combinedImage && (
              <Button
                variant="text"
                color="primary"
                startIcon={<WallpaperRoundedIcon />}
                component="label"
                disabled={isLoading}>
                選擇合成圖片
                <input
                  type="file"
                  accept="image/*"
                  ref={combinedFileRef}
                  onChange={handleCombinedFileChange}
                  style={{ display: 'none' }}
                  disabled={isLoading}
                />
              </Button>
            )}
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        {pageStep === 'list' && (
          <>
            <Button
              color="primary"
              startIcon={<AddCircleOutlinedIcon />}
              variant="contained"
              disabled={isLoading}
              onClick={handleToAddQRCode}>
              新增 QRCode
            </Button>

            <Button
              color="primary"
              startIcon={<MergeTypeRoundedIcon />}
              variant="contained"
              disabled={isLoading || qrcodeTotal <= 0}
              onClick={goToCombined}>
              合併圖片 QRCODE
            </Button>

            <Button
              color="secondary"
              startIcon={<GetAppRoundedIcon />}
              variant="contained"
              disabled={isLoading || qrcodeTotal <= 0}
              onClick={downloadAllQRCode}>
              下載全部待售 QRCode
            </Button>
          </>
        )}

        {pageStep === 'addQRCode' && (
          <>
            <Button
              color="primary"
              startIcon={<AddCircleOutlineRoundedIcon />}
              variant="contained"
              disabled={isLoading}
              onClick={handleAddQRcodes}>
              產生
            </Button>

            <Button
              color="default"
              startIcon={<KeyboardReturnRoundedIcon />}
              variant="contained"
              disabled={isLoading}
              onClick={handleToList}>
              返回
            </Button>
          </>
        )}

        {pageStep === 'combined' && (
          <>
            <Button
              color="secondary"
              startIcon={<GetAppRoundedIcon />}
              variant="contained"
              disabled={isLoading || !combinedImage}
              onClick={downloadCombinedQRCode}>
              下載
            </Button>

            <Button
              color="default"
              startIcon={<KeyboardReturnRoundedIcon />}
              variant="contained"
              disabled={isLoading}
              onClick={handleToList}>
              返回
            </Button>
          </>
        )}

        <Button color="primary" onClick={close} disabled={isLoading}>
          關閉
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BonusProductQRCodeModal;
